import { addDataLayerEntry } from '@printdeal/data-layer-manager';

const eventCategory = 'conversation_app';

export const dispatchDataLayerEventOnSlideOutOpen = () => {
  addDataLayerEntry(eventCategory, {
    eventAction: 'open_slideout',
  });
};

export const dispatchDataLayerEventOnSlideOutClose = () => {
  addDataLayerEntry(eventCategory, {
    eventAction: 'close_slideout',
  });
};

export const dispatchDataLayerEventOnDropdownOpen = () => {
  addDataLayerEntry(eventCategory, {
    eventAction: 'open_dropdown',
  });
};

export const dispatchDataLayerEventOnDropdownClose = () => {
  addDataLayerEntry(eventCategory, {
    eventAction: 'close_dropdown',
  });
};

export const dispatchDataLayerEventOnConversationAppLinkClick = () => {
  addDataLayerEntry(eventCategory, {
    eventAction: 'click_feedback_form',
  });
};

export const dispatchDataLayerEventOnCustomerServiceClick = () => {
  addDataLayerEntry(eventCategory, {
    eventAction: 'click_customer_service',
  });
};
